import { render, staticRenderFns } from "./uiField.vue?vue&type=template&id=437cf918"
import script from "./uiField.vue?vue&type=script&lang=js"
export * from "./uiField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports